import React from "react";

import QuestionResult from "./QuestionResults2";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import {
  Maybe,
  Option,
  Question,
  useGetPollResultsQuery,
  usePollResponsesSubscription,
} from "./generated/graphql";
import {
  DEFCON9,
  DEFCON7,
  DEFCON5,
  DEFCON4,
  DEFCON3,
  DEFCON2,
  DEFCON1,
} from "./debug.json";
import { makeStyles } from "@material-ui/core/styles";
import { version } from "../package.json";

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: 345,
    backgroundSize: "cover",
    position: "fixed",
    minWidth: "100%",
    minHeight: "100%",
    background:
      "linear-gradient(to top, rgb(121, 108, 191, .21) 0%, " +
      "rgba(123, 68, 126, 0.90) " +
      " 100%)",
  },
  media: {
    height: 140,
  },
  contentContainer: {
    background:
      "linear-gradient(to top, rgba(121, 108, 191, .21) 0%, " +
      "rgba(123, 68, 126, 0.90) " +
      " 100%)",
    minWidth: "100%",
    minHeight: "100vh",
  },
  version: {
    marginRight: 16,
    color: "rgba(255, 255, 255, 0.21)",
  },
  total: {
    marginLeft: 16,
  },
  row: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
  },
  rowApart: {
    marginTop: -16,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },

  dynamicFont: {
    fontSize: "1.5rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.8rem",
    },
    [theme.breakpoints.up("md")]: {
      fontSize: "1rem",
    },
    [theme.breakpoints.up("lg")]: {
      fontSize: "1.5rem",
    },
  },
}));
const PollResult = (props: any) => {
  //let {pollId} = useParams();
  const classes = useStyles();

  const { id } = props;
  const pollId: number = parseInt(id);
  const {
    loading: queryLoading,
    error: queryError,
    data: queryData,
  } = useGetPollResultsQuery({ variables: { pollId } });

  const { loading, error, data } = usePollResponsesSubscription({
    variables: { pollId },
  });

  if (error) {
    DEFCON5 && console.log("ERROR:");
    DEFCON5 && console.log(error);
  }

  DEFCON5 && console.log("DATA:");
  DEFCON5 && console.log(data);
  if (!data && !queryData) {
    return null;
  }
  let nada = (
    <div
      style={
        {
          // backgroundImage: `url(${bgImage})`,
        }
      }
      className={classes.root}>
      <Card variant="outlined" className={classes.contentContainer}>
        <Typography gutterBottom variant="h5" component="h2">
          {"Laddar..."}
        </Typography>{" "}
      </Card>
    </div>
  );
  let nadaError = (
    <div
      style={
        {
          // backgroundImage: `url(${bgImage})`,
        }
      }
      className={classes.root}>
      <Card variant="outlined" className={classes.contentContainer}>
        <Typography gutterBottom variant="h5" component="h2">
          {"Some error occured. Please get back later..."}
        </Typography>{" "}
      </Card>
    </div>
  );

  if (queryLoading && loading) return nada;
  if (queryError && error) return nadaError;

  const poll = data ? data?.newResponseAdded?.poll : queryData?.poll;

  let bgImage =
    poll?.imageUrl !== null
      ? poll?.imageUrl
      : "https://sycorax.tritonite.io/titania_common";

  if (!poll) {
    return (
      <div
        style={{
          backgroundImage: `url(${bgImage})`,
        }}
        className={classes.root}>
        <Card variant="outlined" className={classes.contentContainer}>
          <CardContent>
            <Typography gutterBottom variant="h5" component="h2">
              <div>Poll data is missing</div>
            </Typography>
          </CardContent>
        </Card>
      </div>
    );
  }

  DEFCON5 && console.log("ACTIVE FROM: " + poll?.activeFrom);
  DEFCON5 && console.log("ACTIVE TO: " + poll?.activeTo);

  try {
    const tooLate = Date.now() > Date.parse(poll?.activeTo || Math.max);
    const tooSoon = Date.now() < Date.parse(poll?.activeFrom || Math.min);
    if (tooLate || tooSoon) {
      return (
        <div
          style={{
            backgroundImage: `url(${bgImage})`,
          }}
          className={classes.root}>
          <Card variant="outlined" className={classes.contentContainer}>
            <CardContent>
              <Typography gutterBottom variant="h5" component="h2">
                <div>Poll is not active</div>
              </Typography>
            </CardContent>
          </Card>
        </div>
      );
    }
  } catch (e) {
    DEFCON5 && console.log(e);
  }

  const currentResponsesCount = poll?.currentResponsesCount
    ? poll.currentResponsesCount
    : 0;
  const minimumResponsesCount = poll?.minimumResponsesCount
    ? poll.minimumResponsesCount
    : 0;

  DEFCON5 && console.log("MIN: " + minimumResponsesCount);
  DEFCON5 && console.log("CURRENT: " + currentResponsesCount);

  if (poll && currentResponsesCount < minimumResponsesCount) {
    return (
      <div
        style={{
          backgroundImage: `url(${bgImage})`,
        }}
        className={classes.root}>
        <Card variant="outlined" className={classes.contentContainer}>
          <CardContent>
            <Typography gutterBottom variant="h5" component="h2">
              <div>
                {"När vi har tillräckligt många svar presenterar vi dem här."}
              </div>
            </Typography>
          </CardContent>
        </Card>
      </div>
    );
  }

  const questions = poll.questions.nodes as Array<Maybe<Question>>;

  return (
    <div
      style={{
        backgroundImage: `url(${bgImage})`,
      }}
      className={classes.root}>
      <Card className={classes.contentContainer}>
        <CardContent>
          <div className={classes.row}>
            <Typography
              className={classes.dynamicFont}
              gutterBottom
              variant="h6">
              <div>{poll.title}</div>
            </Typography>
          </div>
          {questions.map((question) => {
            if (question) {
              return <QuestionResult key={question.id} data={question} />;
            }
            return null;
          })}
          <div className={classes.rowApart}>
            <Typography
              className={classes.total}
              variant="caption"
              gutterBottom>
              {"Antal svar: " + currentResponsesCount}
            </Typography>
            <Typography
              className={classes.version}
              variant="caption"
              gutterBottom>
              {version}
            </Typography>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default PollResult;
